import { render, staticRenderFns } from "./LoginStaff.vue?vue&type=template&id=b50d7a56&scoped=true&"
import script from "./LoginStaff.vue?vue&type=script&lang=ts&"
export * from "./LoginStaff.vue?vue&type=script&lang=ts&"
import style0 from "./LoginStaff.vue?vue&type=style&index=0&id=b50d7a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50d7a56",
  null
  
)

component.options.__file = "LoginStaff.vue"
export default component.exports